// Image library — every asset is locally hosted via /api/media/
// to guarantee zero CDN dependencies and bulletproof image rendering.
const M = `${process.env.REACT_APP_BACKEND_URL}/api/media`;

export const IMG = {
  hero: `${M}/hero_unsplash.jpg`,
  meetup1: `${M}/meetup1_clean.jpg?v=4`,
  meetup2: `${M}/meetup2.jpg`,
  pickleball: `${M}/pickleball.jpg`,
  dallas: `${M}/dallas.jpg`,
  nola: `${M}/nola.jpg`,
  // ── Real assets from Danny ──
  founder: `${M}/founder.jpg`,
  founderCasual: `${M}/founder_casual.jpg`,
  mavericks: `${M}/mavericks.jpg`,
  communityCircle: `${M}/community-circle.png?v=2`,
  introVideo: `${M}/fotr-intro.mp4?v=2`,
  introVideoPoster: `${M}/fotr-intro-poster.jpg?v=2`,
  heroBgVideo: `${M}/hero_bg_loop.mp4?v=7`,
  heroBgPoster: `${M}/hero_bg_poster.jpg?v=7`,
  tcuMascot: `${M}/tcu_mascot.jpg`,
  tcuVideo: `${M}/tcu_cedric.mp4?v=2`,
  tcuPartnerVideo: `${M}/tcu_partner.mp4`,
  utdVideo: `${M}/utd_partner.mp4`,
  utdVideoPoster: `${M}/utd_partner_poster.jpg`,
  softLaunchVideo: `${M}/softlaunch.mp4`,
  softLaunchPoster: `${M}/softlaunch_poster.jpg?v=4`,
  welcomeVideo: `${M}/welcome.mov`,
  welcomeVideoPoster: `${M}/welcome_poster.jpg?v=2`,
  founderStoryVideo: `${M}/katrina_founder.mp4`,
  founderStoryPoster: `${M}/katrina_founder_poster.jpg`,
  itsProof: `${M}/its_proof.jpg`,
  team: `${M}/team.jpg`,
  logoFull: `${M}/logo_full.png`,
  logoMark: `${M}/logo_mark.png`,
  logoAnimated: `${M}/fotr-logo.gif`,
  meetupVideo: "https://customer-assets.emergentagent.com/job_activity-connect-24/artifacts/67lbi3j3_8ec9868e0ccc4cb89973f308c66fb545.MP4",
  // ── Real app screenshots ──
  appWelcome: "/app_welcome_clean.png",
  appLogin: `${M}/app_login.jpg`,
  appFindFun: `${M}/app_findfun.png`,
  appInterests: `${M}/app_interests_clean.jpg`,
  appCreate: `${M}/app_create_clean.jpg`,
  appLifestyle: `${M}/app_lifestyle.png`,
  appFestival: `${M}/app_festival_clean.png`,
  // ── Inclusive community photos ──
  inclusive1: `${M}/inclusive1.png?v=3`,
  inclusive2: `${M}/inclusive2.jpg`,
  inclusive3: `${M}/inclusive3.png?v=3`,
};

// App store links
export const STORE = {
  ios: "https://testflight.apple.com/join/NyauZBpE",
  android: "https://play.google.com/apps/internaltest/4701693357557936471",
};
